// @flow
import { takeLatest, all } from 'redux-saga/effects';
import {
  UPDATE_NOTIFICATION,
  DISABLE_NOTIFICATION,
  SET_NOTIFICATION_WEEKLY_FREQUENCY,
} from '../actionTypes';
import ApiNotifications from '~/sdk/notifications/email/ApiNotifications';
import clientConfig from '~/../parameters/client/config';
import updateNotification from './updateNotification';
import setNotificationWeeklyFrequency from './setNotificationWeeklyFrequency';
import disableNotification from './disableNotification';

const notificationsApi = new ApiNotifications(clientConfig.notificationApi);

export default function* searchNotificationsSagas(): Generator<*, *, *> {
  yield all([
    takeLatest(UPDATE_NOTIFICATION, updateNotification(notificationsApi)),
    takeLatest(DISABLE_NOTIFICATION, disableNotification(notificationsApi)),
    takeLatest(SET_NOTIFICATION_WEEKLY_FREQUENCY, setNotificationWeeklyFrequency(notificationsApi)),
  ]);
}



// WEBPACK FOOTER //
// ./app/NotificationsManager/email/SearchNotifications/sagas/index.js